import React from "react";
import { mediaUrl } from "../account/media";
import sampleCompany from "../../assets/images/sample-company.svg";

/**
 * A company's uploaded picture (`profile_images`), or the stock company icon when it has none.
 * The stock icon gets `is-sample`: it keeps its own rounded square (no circle crop, cover or tint).
 */
export default function CompanyLogo({ src, className = "portrait carrier-logo" }) {
  const url = src && mediaUrl(src);
  return <img className={`${className}${url ? "" : " is-sample"}`} src={url || sampleCompany} alt="" loading="lazy" />;
}
